import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';

const typeOptions = [
  {
    label: 'NEW',
    value: 'NEW'
  },
  {
    label: 'RENEWAL',
    value: 'RENEWAL'
  }
];

function CreateApplicationStatusModal({
  createInput,
  createApplicationStatus,
  formData,
  getRequirementList,
  history,
  id,
  showRequirement,
  createInputNumber,
  createSelect
}) {

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      system_module_id: id
    }

    createApplicationStatus(payload, ({ data }) => {
      setModal({ isOpen: false });
      getRequirementList();
      history.push(`/general-settings/system-modules/${data.attributes.system_module_id}`);
      showRequirement(data.attributes.system_module_id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'display_name', label: 'Display Name:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'description', label: 'Description:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className='col-12 form-group'>
            {createSelect(
              {
                required: true,
                placeholder: 'Type',
                key: 'type',
                label: 'Type:',
              },
              typeOptions
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'description_filipino', label: 'Tagalog Description:' },
              { minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'other_information', label: 'Other Information:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInputNumber(
              { key: 'amount', label: 'Amount:' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateApplicationStatusModal.propTypes = {
  createSelect: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  createApplicationStatus: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  showRequirement: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateApplicationStatusModal);
